<template>
	<div>
		<h3>{{ $t('monte.add_jument') }}</h3>
		<ActionOverlay ref="saveOverlay" />
		<div>
            <form @submit.prevent>
	            <div class="form-group">
	                <label>
						{{ $t('monte.jument') }}
						<span class="ml-1" v-if="mare && mare.horse_id">
							<router-link :to="{ name: 'HorseFicheInfo', params: { horse_id: mare.horse_id }}">
								<font-awesome-icon :icon="['fal', 'link']" />
							</router-link>
						</span>
					</label>
	                <div class="row">
	                	<div class="col">
			                <SearchJument
								:horse_selected.sync="mare"
								:preselected="mare"
								:online="true"
							/>
			            </div>
			            <div class="col-auto">
		                	<button class="btn btn-secondary" @click="addMare"><font-awesome-icon :icon="['far', 'plus']" /></button>
		                </div>
		            </div>
	            </div>
				<div class="form-group">
	                <div class="row">
	                	<div class="col-12">
			            	<div class="d-flex">
								<b-form-radio v-model="showTier" :value="false" class="mr-2">{{ $t('monte.contact') }}</b-form-radio>
								<b-form-radio v-model="showTier" :value="true" class="mr-2 mb-2">{{ $t('monte.tiers') }}</b-form-radio>
								<span class="ml-1" v-if="showTier && tiers && tiers.tiers_id">
									<router-link :to="{ name: 'tiersTableauBord', params: { tiers_id: tiers.tiers_id }}">
										<font-awesome-icon :icon="['fal', 'link']" />
									</router-link>
								</span>
								<span class="ml-1" v-else-if="contact && contact.contact_id">
									<router-link :to="{ name: 'contactCoordonnees', params: { contact_id: contact.contact_id }}">
										<font-awesome-icon :icon="['fal', 'link']" />
									</router-link>
								</span>
			            	</div>
			            </div>
	                	<div class="col">
			            	<SearchTiers
			            		v-if="showTier"
								:tiers_selected.sync="tiers"
								:search_value.sync="tiers_search_value"
								:preselected="tiers"
								:online="true"
							/>
							<SearchContact
			            		v-else
								:contact_selected.sync="contact"
								:search_value.sync="contact_search_value"
								:preselected="contact"
								:online="true"
							/>
		                </div>
		                <div class="col-auto">
		                	<button class="btn btn-secondary" @click="addTierOrContact"><font-awesome-icon :icon="['far', 'plus']" /></button>
		                </div>
		            </div>
	            </div>
	            <div v-if="has_contact_phone" class="form-group pl-3">
	            	<b-form-checkbox v-model="notify_whatsapp_contact">
	            		<font-awesome-icon :icon="['fab', 'whatsapp']" class="text-success mr-1" />
	            		{{ $t('monte.notify_whatsapp') }} <small class="text-muted">({{ contact_phone_display }})</small>
	            	</b-form-checkbox>
	            </div>
	            <div v-if="mare && mare.horse_id" class="form-group">
	            	<label>
						{{ $t('mouvement.lieu_stationnement') }}
						<span class="ml-1" v-if="lieu_stationnement && lieu_stationnement.tiers_id">
							<router-link :to="{ name: 'tiersTableauBord', params: { tiers_id: lieu_stationnement.tiers_id }}">
								<font-awesome-icon :icon="['fal', 'link']" />
							</router-link>
						</span>
					</label>
					<SearchTiers 
						v-if="showLieuStationnement"
						:tiers_selected.sync="lieu_stationnement"
						:preselected="lieu_stationnement"
						:online="true"
					/>
					<div v-if="has_lieu_phone" class="mt-2 pl-3">
						<b-form-checkbox v-model="notify_whatsapp_lieu">
							<font-awesome-icon :icon="['fab', 'whatsapp']" class="text-success mr-1" />
							{{ $t('monte.notify_whatsapp_lieu') }} <small class="text-muted">({{ lieu_phone_display }})</small>
						</b-form-checkbox>
					</div>
	            </div>
	            <div v-if="!no_couple && no_contract" class="alert alert-warning">{{ $t('monte.no_contract') }}</div>
	            <div v-if="no_couple" class="alert alert-warning">{{ $t('monte.no_couple') }}</div>
	            <div v-if="selected_stallion_saillie_count > 0" class="alert alert-warning">{{ $t('monte.saillie_count', { count: selected_stallion_saillie_count }) }}</div>
	            <div v-if="stallion_preselected" class="alert alert-danger">{{ $t('monte.defaut_stallion_is') }} {{ default_stallion.horse_nom }}</div>
	            <div v-if="mare && mare.horse_id" class="form-group">
	                <label>{{ $t('gynecologie.mare_status_monte') }}</label>
	                <div class="row">
	                	<div class="col">
			                <e-select
	                            v-model="mare_status_selected"
	                            id="marestatus_id"
	                            track-by="marestatus_id"
	                            :placeholder="$t('gynecologie.selectionnez_etat')"
	                            :selectedLabel="$t('global.selected_label')"
	                            :options="mare_status"
	                            :searchable="false"
	                            :allow-empty="false"
	                            :show-labels="false"
	                        >
	                            <template slot="option" slot-scope="{ option }">{{ $t('gynecologie.'+option.marestatus_code) }}</template>
	                            <template slot="singleLabel" slot-scope="{ option }">{{ $t('gynecologie.'+option.marestatus_code) }}</template>
	                            <template slot="noOptions">{{ $t('global.list_empty') }}</template>
	                        </e-select>
	                    </div>
		            </div>
	            </div>
	            <div v-if="mare && mare.horse_id" class="form-group">
	            	<div class="row">
	                	<div class="col">
	            			<b-form-checkbox id="seasonmare_sanitary" v-model="sanitary"><label for="seasonmare_sanitary">{{ $t("gynecologie.sanitaire_complet") }}</label></b-form-checkbox>
	            		</div>
	            	</div>
	            </div>
	            <div class="form-group">
	            	<label>{{ $t('monte.stallion_singular') }}
						<span class="ml-1" v-if="stallion && JSON.stringify(stallion) != '{}'">
							<router-link :to="{ name: 'HorseFicheInfo', params: { horse_id: stallion.horse_id }}">
								<font-awesome-icon :icon="['fal', 'link']" />
							</router-link>
						</span>
					</label>
	                <e-select
	                    v-model="stallion"
	                    id="stallion"
	                    track-by="horse_id"
	                    label="horse_nom"
	                    :placeholder="$t('monte.selectionnez_etalon')"
	                    :selectedLabel="$t('global.selected_label')"
	                    :options="stallion_dispo"
	                    :searchable="true"
	                    :allow-empty="false"
	                    :show-labels="false"
	                />
	            </div>
				<div class="row">
					<div class="form-group col-6">
						<label>{{ $t('monte.date') }}</label>
						<e-datepicker v-model="date"></e-datepicker>
					</div>
					<div class="form-group col-6">
						<label>{{ $t('monte.creneau') }}</label>
						<e-select
							v-model="schedule"
							id="schedule"
							track-by="schedule_id"
							:placeholder="$t('monte.selectionnez_schedule')"
							:selectedLabel="$t('global.selected_label')"
							:options="schedule_dispo"
							:searchable="true"
							:allow-empty="false"
							:show-labels="false"
						>
							<template slot="option" slot-scope="{ option }">{{ option.schedule_start }} - {{ option.schedule_end }}</template>
							<template slot="singleLabel" slot-scope="{ option }">{{ option.schedule_start }} - {{ option.schedule_end }}</template>
							<template slot="noOptions">{{ $t('global.list_empty') }}</template>
						   </e-select>
					</div>
				</div>

	            <div class="form-group">
                    <label>{{ $t('formulaire.ajouter_commentaire') }}</label>
                    <e-editor-froala
                        ref="froala_creneau_comment"
                        identifier="creneau_commentaire"
                        :placeholder="$t('formulaire.votre_commentaire')"
                        :content="commentaire"
                        @change="updateCreneauCommentEditor"
                        :moreText="froala_more_text"
                        :enableImage="false"
                    ></e-editor-froala>
                </div>

	            <div class="form-group">
	            	<label class="d-block">{{ $t('monte.commentaire_color') }}</label>
	            	<div class="d-flex flex-wrap">
	            		<button
	            			v-for="color in comment_colors"
	            			:key="color"
	            			type="button"
	            			class="btn mr-2 mb-2"
	            			:class="['alert-' + color, commentaire_color === color ? 'border border-dark font-weight-bold' : '']"
	            			@click="commentaire_color = color"
	            		>
	            			{{ $t('monte.commentaire_color_' + color) }}
	            		</button>
	            	</div>
	            </div>

	            <div class="text-center mt-5">
	                <b-button @click="checkForm" variant="primary" class="rounded-pill" :disabled="processing">
	                    <template v-if="schedule_info">
	                    	{{ $t('global.modifier') }}
	                	</template>
	                	<template v-else>
	                    	{{ $t('global.ajouter') }}
	                	</template>
	                	<span class="ml-1 small opacity-50">({{ isMac ? '⌘' : 'Ctrl' }}+S)</span>
	                </b-button>
	                <b-button @click="cancelAjout" class="rounded-pill ml-1">
					{{ $t('global.annuler') }} <span class="ml-1 small opacity-50">(Esc)</span>
					</b-button>
	            </div>
	        </form>
        </div>
	</div>
</template>

<script type="text/javascript">
	import Vue from 'vue'
	import { EventBus } from 'EventBus'
	import ShutterPanel from 'GroomyRoot/components/Utils/ShutterPanel'
	import Shutter from '@/mixins/Shutter'
	import MonteShutters from '@/mixins/shutters-manager/Monte'
	import Horse from '@/mixins/Horse'
	import Tiers from '@/mixins/Tiers'
	import PlanningMonte from '@/mixins/PlanningMonte'
	import Contact from '@/mixins/Contact'
	import Gynecologie from '@/mixins/Gynecologie'
	import Contract from '@/mixins/Contract'
	import Constants from '../../../config.local'

	export default {
		name: 'AjoutMonteMainBeta',
		props: ['horse_id', 'schedule_info', 'planning_id', 'schedule_id', 'date_preselected', 'season_id', 'stallions', 'schedules'],
		mixins: [Shutter, MonteShutters, Horse, PlanningMonte, Contact, Gynecologie, Contract, Tiers],
		data () {
			return {
				mare: {},
				stallion: null,
				stallion_dispo: [],
				contact: null,
				schedule: null,
				schedule_dispo: [],
				date: null,
				mare_status_selected: null,
				mare_status: [],
				all_schedule: [],
				sanitary: false,
				commentaire: "",
				commentaire_color: 'info',
				comment_colors: ['info', 'warning', 'danger', 'success'],
				froala_more_text: ['bold', 'italic', 'underline', 'strikeThrough', 'undo', 'redo', 'formatUL', 'formatOL', 'clearFormatting'],
				no_contract: false,
				no_couple: false,
				showTier: true,
				tiers: null,
				lieu_stationnement: null,
				stallion_preselected: false,
				tiers_search_value: '',
				contact_search_value: '',
				processing: false,
				default_stallion: null,
				showLieuStationnement: true,
				notify_whatsapp_contact: false,
				notify_whatsapp_lieu: false,
				mare_context: null
			}
		},

		mounted() {
			this.init_component()
			document.addEventListener('keydown', this._onKeydown)
			EventBus.$on('PlanningMonte::ws-reload', this._onWsReloadSchedules)
		},

		beforeDestroy() {
			document.removeEventListener('keydown', this._onKeydown)
			EventBus.$off('PlanningMonte::ws-reload', this._onWsReloadSchedules)
		},

		methods: {
			/**
			 * Synchronise le contenu de l'éditeur Froala du commentaire de créneau
			 */
			updateCreneauCommentEditor(hook) {
				this.commentaire = hook.val
			},

			async init_component() {
				this.mare_status = await this.loadMareStatus()

				if(!this.schedule_info) {
					this.loadStallion()
					if(this.date_preselected) {
						this.date = this.date_preselected
					}
				}
				else {
					this.mare = this.schedule_info.mare ? this.schedule_info.mare : {}
					this.date = new Date(this.schedule_info.date)
					this.contact = this.schedule_info.contact
					this.loadStallion(this.schedule_info.stallion.horse_id)
					this.commentaire = this.schedule_info.commentaire || ''
					this.commentaire_color = this.schedule_info.commentaire_color || 'info'
					this.$nextTick(() => {
						if(this.$refs.froala_creneau_comment) {
							this.$refs.froala_creneau_comment.setValue(this.commentaire)
						}
					})
					this.tiers = this.schedule_info.tiers
					if(this.contact) {
						this.showTier = false
					}
				}

				this.all_schedule = this.schedules
			},

			async addMare() {
				let shutter = this.monteShutters['monte-horse-ajout']
				shutter.props.season_id = this.season_id

				shutter.onOk = async (horse_id) => {
					if(this.contact) {
						await this.setContactHorse(horse_id)
					}
					this.mare = await this.getHorseById(horse_id)
				}

				this.shutterPanel().open(shutter)	
			}, 

			addTierOrContact() {
				if(this.showTier) {
					this.openAddTier()
				}
				else {
					this.addContact()
				}
			},

			addContact() {
				let shutter = this.monteShutters['monte-contact-ajout']

				if(this.mare && this.mare.horse_id) {
					shutter.props.horse_id = this.mare.horse_id
				}

				this.shutterPanel().open(shutter)	
			},

			openAddTier() {
				let shutter = this.monteShutters['ajout-tiers']

				this.shutterPanel().open(shutter)
			},

			async setContactHorse(horse_id) {
				if(this.contact.contact_id) {
					await this.addHorseContact(horse_id, this.contact.contact_id)
				}
			},

			async loadStallion() {
				this.stallion_dispo = this.stallions
				this.stallion = this.stallion_dispo.find(stallion => stallion.horse_id == this.horse_id)
			},

			async _onWsReloadSchedules({ date }) {
				if (!this.stallion || !this.stallion.horse_id) return
				if (!this.date || new Date(this.date).toDateInputValue() !== date) return
				const selected_id = this.schedule && this.schedule.schedule_id ? this.schedule.schedule_id : null
				await this.loadSchedules()
				if (selected_id && !this.schedule_dispo.find(s => s.schedule_id === selected_id)) {
					this.schedule = {}
					this.infoToast('monte.creneau_pris_ws')
				}
			},

			async loadSchedules() {
				let schedule_taken = await this.getSchedulesByStallionMainOnline(this.stallion.horse_id, this.date)
				schedule_taken = schedule_taken.map(schedule => schedule.schedulehorse_schedule)
				this.schedule_dispo = this.all_schedule.filter(schedule => {
					if(this.schedule_id && schedule.schedule_id == this.schedule_id) return true
					return !schedule_taken.includes(schedule.schedule_id)
				})

				this.schedule = {}
				if(this.schedule_id) {
					this.schedule = this.schedule_dispo.find(schedule => schedule.schedule_id == this.schedule_id)
				}
			},

			_onKeydown(e) {
				if((this.isMac ? e.metaKey : e.ctrlKey) && e.key.toLowerCase() === 's') {
					e.preventDefault()
					if(!this.processing) {
						this.checkForm()
					}
				}
				if(e.key === 'Escape') {
					this.cancelAjout()
				}
			},

			cancelAjout() {
				this.cancel()
				this.shutterPanel().close('monte-horse-ajout')
				this.shutterPanel().close('monte-contact-ajout')
			},

			async checkForm() {
				if(!this.stallion || !this.stallion.horse_id) {
					this.failureToast('monte.no_stallion_selected')
					return
				}
				if(!this.schedule || !this.schedule.schedule_id) {
					this.failureToast('monte.no_schedule_selected')
					return
				}
				this.processing = true
				this.$refs.saveOverlay.show()
				const mare = (this.mare && this.mare.horse_id) ? this.mare.horse_id : null;
				const contact = (!this.showTier && this.contact) ? this.contact.contact_id : null;
				const tiers = (this.showTier && this.tiers && this.tiers.tiers_id) ? this.tiers.tiers_id : null;

				const schedulehorse_id = this.schedule_info ? this.schedule_info.id : null
				const seasonmare_id = this.mare_context ? this.mare_context.seasonmare_id : null

				if(mare && seasonmare_id && this.mare_status_selected) {
					await this.saveStatutSanitary(seasonmare_id, this.mare_status_selected.marestatus_id, this.sanitary)
				}
				else if(mare && seasonmare_id) {
					await this.saveStatutSanitary(seasonmare_id, null, this.sanitary)
				}

				if(mare && seasonmare_id) {
					const seasonmarestallion = await this.getSeasonMareStallionDefaultBySeasonMare(seasonmare_id)
					if(!seasonmarestallion || seasonmarestallion.seasonmarestallion_horse != this.stallion.horse_id) {
						await this.editAllSeasonMareStallionDefault(seasonmare_id, { seasonmarestallion_default: 0 })
						const seasonstallion = await this.getSeasonMareStallionBySeasonMareAndStallion(seasonmare_id, this.stallion.horse_id)
						if(!seasonstallion) {
							await this.addSeasonMareStallion(seasonmare_id, this.stallion.horse_id, null, 1)
						} else {
							await this.editSeasonMareStallion(seasonstallion.seasonmarestallion_id, { seasonmarestallion_default: 1 })
						}
					}

					if(this.mare.horse_id && this.lieu_stationnement && this.lieu_stationnement.tiers_id) {
            			await this.assignLieuStationnement(this.mare.horse_id, this.lieu_stationnement.tiers_id)
					}
				}

				const comment_html = this.commentaire || ''
				const stripped = comment_html.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, '').trim()
				const comment_text = stripped ? comment_html : ''
				const comment_color = stripped ? this.commentaire_color : null
				const res = await this.saveScheduleHorseOnline("main", this.stallion.horse_id, this.schedule.schedule_id, mare, contact, this.date, schedulehorse_id, comment_text, tiers, comment_color)

				if(res) {
					this.openWhatsappNotifications()
					await this.$refs.saveOverlay.showSuccess()
					this.processing = false
					this.ok()
					this.shutterPanel().close('monte-main-ajout-beta')
					this.shutterPanel().close('monte-horse-ajout')
					this.shutterPanel().close('monte-contact-ajout')
				} else {
					this.$refs.saveOverlay.hide()
					this.processing = false
				}
			},

			/**
			 * Construit le numéro utilisable pour wa.me (chiffres uniquement)
			 * @param {string} phone
			 * @returns {string}
			 */
			formatWhatsappPhone(phone) {
				if(!phone) return ''
				return phone.replace(/[^0-9]/g, '')
			},

			/**
			 * Récupère le premier numéro "combiné" disponible pour le tiers/contact sélectionné
			 * @returns {string|null}
			 */
			getContactPhone() {
				if(this.showTier && this.tiers && Array.isArray(this.tiers.phones) && this.tiers.phones.length > 0) {
					return this.tiers.phones[0].phone_combine
				}
				if(!this.showTier && this.contact && Array.isArray(this.contact.phones) && this.contact.phones.length > 0) {
					return this.contact.phones[0].phone_combine
				}
				return null
			},

			/**
			 * Récupère le premier numéro "combiné" disponible pour le lieu de stationnement
			 * @returns {string|null}
			 */
			getLieuPhone() {
				if(this.lieu_stationnement && Array.isArray(this.lieu_stationnement.phones) && this.lieu_stationnement.phones.length > 0) {
					return this.lieu_stationnement.phones[0].phone_combine
				}
				return null
			},

			/**
			 * Construit le message WhatsApp à envoyer
			 * @returns {string}
			 */
			buildWhatsappMessage() {
				const mare_nom = this.mare && this.mare.horse_nom ? this.mare.horse_nom : ''
				const stallion_nom = this.stallion && this.stallion.horse_nom ? this.stallion.horse_nom : ''
				const date_str = this.date ? new Date(this.date).toLocaleDateString(Vue.i18n.locale()) : ''
				const heure_str = this.schedule && this.schedule.schedule_start ? this.schedule.schedule_start : ''
				return this.getTrad('monte.whatsapp_message', {
					mare: mare_nom,
					stallion: stallion_nom,
					date: date_str,
					heure: heure_str
				})
			},

			/**
			 * Ouvre les onglets WhatsApp selon les cases cochées
			 */
			openWhatsappNotifications() {
				const message = encodeURIComponent(this.buildWhatsappMessage())
				if(this.notify_whatsapp_contact) {
					const phone = this.formatWhatsappPhone(this.getContactPhone())
					if(phone) {
						window.open('https://wa.me/' + phone + '?text=' + message, '_blank')
					}
				}
				if(this.notify_whatsapp_lieu) {
					const phone = this.formatWhatsappPhone(this.getLieuPhone())
					if(phone) {
						window.open('https://wa.me/' + phone + '?text=' + message, '_blank')
					}
				}
			},

			async loadContractInfo() {
				this.no_contract = false
				if(!this.mare || !this.mare.horse_id) return false
				if(!this.stallion || !this.stallion.horse_id) return false

				if (this.mare_context && this.mare_context.season_stallions) {
					const match = this.mare_context.season_stallions.find(s => s.stallion_id == this.stallion.horse_id)
					if (!match) {
						this.no_contract = true
					}
				} else {
					this.no_contract = true
				}
			},

			async checkSeasonMareStallion() {
				this.no_couple = false
				if(!this.stallion || !this.stallion.horse_id) return
				if(!this.mare_context) return

				if (this.mare_context.season_stallions && this.mare_context.season_stallions.length > 0) {
					const match = this.mare_context.season_stallions.find(s => s.stallion_id == this.stallion.horse_id)
					if (!match) {
						this.no_couple = true
					}
				} else {
					this.no_couple = true
				}
			},

			async loadMareContext() {
				if (!this.mare || !this.mare.horse_id || !this.season_id) {
					this.mare_context = null
					return
				}

				const context = await this.getMareContext(this.mare.horse_id, this.season_id)

				if (context) {
					this.mare_context = context

					// Pré-remplir le lieu de stationnement
					if (this.mare_context.lieu_stationnement) {
						this.lieu_stationnement = this.mare_context.lieu_stationnement
					}

					// Pré-remplir le contact (responsable d'élevage en priorité)
					if (!this.schedule_info && this.mare_context.contacts && this.mare_context.contacts.length > 0) {
						const resp = this.mare_context.contacts.find(c => c.fonctions && c.fonctions.includes('RESPELEV'))
						this.contact = resp || this.mare_context.contacts[0]
					}

					// Pré-remplir le tiers (propriétaire principal)
					if (!this.schedule_info && this.mare_context.tiers && this.mare_context.tiers.length > 0) {
						this.tiers = this.mare_context.tiers[0]
						this.showTier = true
					}

					// Statut mare
					if (this.mare_context.seasonmare_status) {
						this.mare_status_selected = this.mare_status.find(s => s.marestatus_id == this.mare_context.seasonmare_status)
					}
					this.sanitary = this.mare_context.seasonmare_sanitary || false

					// Étalon par défaut
					this.stallion_preselected = false
					if (this.mare_context.season_stallions && this.mare_context.season_stallions.length > 0) {
						const defaultSms = this.mare_context.season_stallions.find(s => s.seasonmarestallion_default)
						if (defaultSms) {
							const new_stallion = this.stallion_dispo.find(st => st.horse_id == defaultSms.stallion_id)
							if (new_stallion && (!this.stallion || new_stallion.horse_id != this.stallion.horse_id) && !this.schedule_info) {
								this.default_stallion = new_stallion
								this.stallion_preselected = true
							}
						}
					}
				} else {
					this.mare_context = null
				}
			}
		},

		computed: {
			selected_stallion_saillie_count() {
				if (!this.mare_context || !this.stallion || !this.stallion.horse_id) return null
				if (!this.mare_context.season_stallions) return null
				const match = this.mare_context.season_stallions.find(s => s.stallion_id == this.stallion.horse_id)
				return match ? match.saillie_count : 0
			},
			contact_phone_display() {
				return this.getContactPhone() || ''
			},
			lieu_phone_display() {
				return this.getLieuPhone() || ''
			},
			has_contact_phone() {
				return !!this.getContactPhone()
			},
			has_lieu_phone() {
				return !!this.getLieuPhone()
			}
		},

		watch: {
			async mare (val) {
				await this.loadMareContext()
				this.loadContractInfo()
				this.checkSeasonMareStallion()
				this.showLieuStationnement = false
				this.$nextTick(() => {
					this.showLieuStationnement = true
				})
			},

			stallion (val) {
				if(val) { 
					this.loadSchedules()
					this.loadContractInfo()
					this.checkSeasonMareStallion()
				}
			},

			date() {
				if(this.stallion) {
					this.loadSchedules()
				}
			},

			showTier(val) {
				if(val) {
					this.tiers_search_value = this.contact_search_value
				}
				else {
					this.contact_search_value = this.tiers_search_value
				}
			},

			async tiers(val) {
				// SearchTiers renvoie un tiers brut sans la propriété phones[].
				// On recharge via loadTier (TierTransformer 'withPhone') pour permettre la notification WhatsApp.
				if(val && val.tiers_id && !Array.isArray(val.phones)) {
					const enriched = await this.loadTier(val.tiers_id)
					if(enriched && Array.isArray(enriched.phones)) {
						this.tiers = enriched
					}
				}
			},

			async lieu_stationnement(val) {
				if(val && val.tiers_id && !Array.isArray(val.phones)) {
					const enriched = await this.loadTier(val.tiers_id)
					if(enriched && Array.isArray(enriched.phones)) {
						this.lieu_stationnement = enriched
					}
				}
			}
		},

		components: {
			SearchTiers : () => import('@/components/Contract/SearchTiers'),
			SearchContact : () => import('@/components/Contract/SearchContact'),
			SearchJument : () => import('@/components/Contract/SearchJument'),
			ActionOverlay: () => import('@/components/Utils/ActionOverlay')
		}
	}

</script>